import React, { memo, useEffect, useState } from 'react';
import '../../css/RequestsPage.css'
import { useDispatch, useSelector } from 'react-redux';
import { RequestsActions } from '../../_store/Requests.slice';
import ApplicationForm from './ApplicationForm';
import VisitorInformation from './VisitorInformation';
import RequestRemedyForm from './RequestRemedyForm';
import CustomModal from '../../components/common/CustomModal ';
import LegalResearchRequest from './LegalResearchRequest';
import RequestFormInfo from './RequestFormInfo';
import Table from '../../components/common/CustomTable';
import Button from '../../components/common/ui/Button';
import SelectInput from '../../components/common/ui/Inputs/SelectInput';
import { KioskDashboardActions } from '../../_store';
import ScrollContainer from '../../components/common/ScrollContainer';
import TranslateFile from '../../Loc/TranslateFile';
import Loader from '../../components/common/Loader';
import useKioskRestrictIntervalValidation from '../../hooks/useKioskRestrictIntervalValidation';
import { getStoredValue } from "../../_helpers/storageHelper";
import PublicDefenderServiceForm from './PublicDefenderServiceForm';

const Requests = () => {
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const { InmateRequestFormPermissionDetails, InmateRequestFormSearchDetails, InmateMGUserRequestFormSearchDetails, LoadFacilityRequestFormPermissionDetails,
        ValidateInmateCreateRequestFormDetails, LoadInmateMGUserRequestUnReadCountResponse } = useSelector(state => state.Requests);
    const dispatch = useDispatch();
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [isShowGrid, setisShowGrid] = useState(false);
    const [isShowinboxlist, setisShowinboxlist] = React.useState(false);
    const [isEdit, setisEdit] = React.useState(false);
    const [selectformcategory, setselectformcategory] = React.useState('')
    const [iscreate, setiscreate] = React.useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setModalContent] = useState();
    const [selectrowItem, setselectrowItem] = useState('');
    const [errorMessage, setErrorMessage] = useState({});
    const [formVisibility, setFormVisibility] = useState({
        divVisitorInfo: false,
        divForumRequestInfo: false,
        divlegalResearch: false,
        divForumForm: false,
        divApplicationForm: false,
        divPDSRequestForm: false,
    });
    const [isPdfdata, setisPdfdata] = React.useState();
    const [isshowFeedbackbtn, setisshowFeedbackbtn] = React.useState(false);
    const [isshowNotice, setisshowNotice] = React.useState(false);
    const currentLang = TranslateFile();
    const [currentPage, setcurrentPage] = React.useState(1);
    const [rowPerPage, setrowPerPage] = React.useState(10);
    const [isLoading, setisLoading] = React.useState(false);
    const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
    const { isPageReload: isPageReloading, isSignalRData } = useSelector((state) => state.auth);


    useEffect(() => {
        setselectformcategory(''); setErrorMessage({}); setisShowGrid(false);
        setcurrentPage(1); setrowPerPage(10);
        setisshowFeedbackbtn(false);
        setisLoading(true);
        dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse)).then(x => {
            setisLoading(false)
        });
        if (isPdfdata) {
            setisPdfdata(''); return;
        }
        if (formVisibility.divForumRequestInfo && isShowinboxlist) {
            setFormVisibility({
                divForumRequestInfo: false, divRequest: false, divVisitorInfo: false, divlegalResearch: false, divApplicationForm: false, divPDSRequestForm: false
            });
            setisEdit(false);
        }
        else {
            setisShowinboxlist(false); setisEdit(false); setiscreate(false);
            setFormVisibility({
                divForumRequestInfo: false, divRequest: false, divVisitorInfo: false, divlegalResearch: false, divApplicationForm: false, divPDSRequestForm: false
            });
        }
    }, [isPageReloading]);

    useEffect(() => {
        if (storedloginResponse?.FacilityCode) {
            setisLoading(true);
            dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse)).then(x => {
                setisLoading(false)
            });
            handlemessageFrominboxCount();
        }
    }, []);

    useEffect(() => {
        if (isSignalRData?.type == "Reply_Admin_MessageFromInbox") {
            handlemessageFrominboxCount();
            // if (isShowinboxlist)
            //     handleMessageFromInbox();
        }
    }, [isSignalRData]);

    // useEffect(() => {
    //     if (!isSignalRData?.type) return;
    //     switch (true) {
    //         case selectformcategory === 1:
    //             // "Reply_Admin_VisitorForm"
    //             if (isSignalRData?.type === "Reply_Admin_VisitorForm") {
    //                 handleRequestFormType(selectformcategory, true);
    //                 dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             }
    //             break;
    //         case selectformcategory === 2:
    //             // "Reply_Admin_RemedyForm"
    //             if (isSignalRData?.type === "Reply_Admin_RemedyForm") {
    //                 handleRequestFormType(selectformcategory, true);
    //                 dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             }
    //             break;
    //         case selectformcategory >= 3 && ![53, 59, 63, 60, 62].includes(selectformcategory):
    //             // "Reply_Admin_RequestFormInfo"
    //             if (isSignalRData?.type === "Reply_Admin_RequestFormInfo") {
    //                 handleRequestFormType(selectformcategory, true);
    //                 dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             }
    //             break;
    //         case selectformcategory === 53:
    //             // "Reply_Admin_PublicDefenderForm"
    //             if (isSignalRData?.type === "Reply_Admin_PublicDefenderForm") {
    //                 handleRequestFormType(selectformcategory, true);
    //                 dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             }
    //             break;
    //         case [59, 62, 63].includes(selectformcategory):
    //             // "Reply_Admin_CRISPForm";
    //             if (isSignalRData?.type === "Reply_Admin_CRISPForm") {
    //                 handleRequestFormType(selectformcategory, true);
    //                 dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             }
    //             break;
    //         case selectformcategory === 60:
    //             //Reply_Admin_LegalForm
    //             if (isSignalRData?.type === "Reply_Admin_LegalForm") {
    //                 handleRequestFormType(selectformcategory, true);
    //                 dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             }
    //             break;
    //         default:
    //             dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse));
    //             break;
    //     }
    // }, [isSignalRData, selectformcategory]);

    useEffect(() => {
        validateKioskRestrictInterval(storedLoginDetails)
    }, []);

    const handlemessageFrominboxCount = () => {
        var Objectdata = {
            inmatesId: storedloginResponse?.InmateID, facilityID: storedloginResponse?.facilityID,
        };
        dispatch(RequestsActions.LoadInmateMGUserRequestUnReadCount(Objectdata));
    }

    useEffect(() => {
        if (iscreate && LoadFacilityRequestFormPermissionDetails?.length > 0 && ValidateInmateCreateRequestFormDetails?.length > 0) {
            const permissionStatus = LoadFacilityRequestFormPermissionDetails?.find(a => a.RequestFormTypeID === selectformcategory);
            const inmateValidation = ValidateInmateCreateRequestFormDetails[0];

            if (inmateValidation?.IsInmateValidCreateNewRequest > 0) {
                const formCategoryVal = parseInt(selectformcategory, 10);

                if (formCategoryVal > 0) {
                    const { NoOfRequestLimitSet, ActiveStatus } = inmateValidation;

                    if (NoOfRequestLimitSet === 0 || ActiveStatus === 0 || ActiveStatus === 2) {
                        setShowPopup(true); setiscreate(false);
                        setModalContent(currentLang?.AlertPopup?.Not_Allowed_Forms);
                    } else {
                        getFormVisibility(formCategoryVal);
                    }
                }
            } else {
                const { NoOfRequestLimitSet } = inmateValidation;

                if (permissionStatus?.ActiveStatus === 0 || NoOfRequestLimitSet === 0) {
                    setShowPopup(true); setiscreate(false);
                    setModalContent(currentLang?.AlertPopup?.Not_Allowed_Forms);
                } else {
                    setShowPopup(true); setiscreate(false);
                    setModalContent(currentLang?.AlertPopup?.Form_Limit_Reached);
                }
            }
        }
    }, [ValidateInmateCreateRequestFormDetails, iscreate, LoadFacilityRequestFormPermissionDetails, selectformcategory]);

    const getFormVisibility = (formCategoryVal) => {
        const visibilitySettings = {
            divVisitorInfo: false,
            divRequest: false,
            divForumRequestInfo: false,
            divlegalResearch: false,
            divApplicationForm: false,
            divPDSRequestForm: false,
        };

        switch (true) {
            case formCategoryVal === 1:
                visibilitySettings.divVisitorInfo = true;
                break;
            case formCategoryVal === 2:
                visibilitySettings.divRequest = true;
                break;
            case formCategoryVal >= 3 && ![53, 59, 63, 60, 62].includes(formCategoryVal):
            case formCategoryVal === 53:
                visibilitySettings.divForumRequestInfo = true;
                break;
            case [59, 62].includes(formCategoryVal):
                visibilitySettings.divApplicationForm = true;
                break;
            case [63].includes(formCategoryVal):
                visibilitySettings.divPDSRequestForm = true;
                break;
            case formCategoryVal === 60:
                visibilitySettings.divlegalResearch = true;
                break;
            default:
                break;
        }

        setFormVisibility(visibilitySettings);
    };

    const handleBack = () => {
        // setcurrentPage(1); setrowPerPage(10);
        setisshowFeedbackbtn(false);
        setisLoading(true);
        dispatch(RequestsActions.getInmateRequestFormPermission(storedloginResponse)).then(x => {
            setisLoading(false)
        });
        handlemessageFrominboxCount();
        if (isShowinboxlist && isEdit) {
            handleMessageFromInbox();
        }
        if (isPdfdata) {
            setisPdfdata(''); return;
        }
        if (formVisibility.divForumRequestInfo && isShowinboxlist) {
            setFormVisibility({
                divForumRequestInfo: false, divRequest: false, divVisitorInfo: false, divlegalResearch: false, divApplicationForm: false, divPDSRequestForm: false
            });
            setisEdit(false);
        }
        else {
            setisShowinboxlist(false); setisEdit(false); setiscreate(false);
            setFormVisibility({
                divForumRequestInfo: false, divRequest: false, divVisitorInfo: false, divlegalResearch: false, divApplicationForm: false, divPDSRequestForm: false
            });
            if (selectformcategory)
                handleRequestFormType(selectformcategory);
        }
    }


    const handleRequestFormType = (value, isnoloading = false) => {
        if (!isnoloading) { setisLoading(true); }
        setselectformcategory(value);
        var Objectdata = {
            noticesID: value, pageNo: currentPage, rowCountPerPage: rowPerPage,
            facilityID: storedloginResponse?.facilityID, inmateID: storedloginResponse?.InmateID,
        };
        dispatch(RequestsActions.getInmateRequestFormSearch(Objectdata)).then(x => {
            setisLoading(false)
        });
        setisShowGrid(true);
    }

    const columns = [
        {
            name: currentLang?.TableHeaders?.Form_Title, selector: (row) => row.RequestFormTitle, sortable: true,
            cell: (row) => (
                <div className="d-flex " onClick={() => handleONCLick(row)}>
                    <div>
                        {row.RequestFormTitle}
                    </div>
                    {(row.IsInmateReadStatus === false || row?.IsInmateReadStatus == 0) && (
                        <div className="newbutton-container ms-2">
                            {currentLang?.E_Cards?.New}
                            <div className="border-animation"></div>
                        </div>
                    )}
                </div>
            )
        },
        { name: currentLang?.TableHeaders?.Inmate_Name, selector: (row) => row.InmateName, sortable: true },
        {
            name: currentLang?.TableHeaders?.Created_Date, selector: (row) => row.RequestCreateDate, sortable: true,
            sortFunction: (a, b) => new Date(a.RequestCreateDate) - new Date(b.RequestCreateDate),
        },
        {
            name: currentLang?.TableHeaders?.Resubmit_Date, selector: (row) => row.RequestRespondDate, sortable: true,
            sortFunction: (a, b) => new Date(a.RequestRespondDate) - new Date(b.RequestRespondDate),
        },
        {
            name: currentLang?.TableHeaders?.Status, selector: (row) => RequestCurrentStatus(row.RequestCurrentStatus), sortable: true,
            cell: (row) => (
                <div className="d-flex " title={row.RequestCurrentStatus} onClick={() => { handleONCLick(row) }}>
                    {RequestCurrentStatus(row.RequestCurrentStatus)}
                </div>
            ),
        },
    ];
    const RequestCurrentStatus = (status) => {
        const statusClasses = {
            open: "StatusSent",
            sent: "StatusSent",
            closed: 'StatusPatch-danger',
            read: "StatusSent",
            rejected: 'StatusPatch-danger',
            waiting: 'StatusPatch-danger',
            unread: 'StatusPatch-danger'
        };
        return <span className={statusClasses[status?.toLowerCase()]}>{status}</span>;
    };

    const handleONCLick = (item) => {
        setselectrowItem(item);
        getFormVisibility(item?.RequestFormType);
        setisEdit(true)
        if (item?.IsInmateReadStatus == false && selectrowItem?.IsInmateReadStatus !== 0) {
            var Objectdata = {
                inmatesId: item?.InmateID, facilityID: storedloginResponse?.facilityID,
                formReqAccess: item?.RequestFormTypeID, requestAdminRemedyID: selectformcategory,
            };
            dispatch(RequestsActions.LoadUpdateInmateRequestRead(Objectdata)).then((x => {
                const podCode = storedLoginDetails?.PodCode;
                const inmateID = storedloginResponse?.InmateID;
                if (inmateID && podCode)
                    dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
            }))
        }
    }

    const handleMessageFromInbox = () => {
        setisLoading(true);
        var Objectdata = {
            requestFormTypeID: 0, pageNo: currentPage, rowCountPerPage: rowPerPage,
            facilityID: storedloginResponse?.facilityID, inmatesId: storedloginResponse?.InmateID,
        };
        dispatch(RequestsActions.getInmateMGUserRequestFormSearch(Objectdata)).then(x => {
            setisLoading(false)
        });
        setisShowinboxlist(true); setisShowGrid(true); setselectformcategory(''); setErrorMessage({}); setisShowGrid(false)
    }

    const handlecreatefunction = () => {
        setErrorMessage({})
        if (selectformcategory) {
            setisLoading(true);
            var inmateId = storedloginResponse?.InmateID; var facilityId = storedloginResponse?.facilityID; var requestFormTypeId = selectformcategory
            dispatch(RequestsActions.getLoadFacilityRequestFormPermission(storedloginResponse)).then(x => {
                setisLoading(false)
            });
            setisLoading(true);
            dispatch(RequestsActions.getValidateInmateCreateRequestForm({ inmateId, facilityId, requestFormTypeId })).then(x => {
                setisLoading(false)
            });
            if ([59, 62, 63]?.includes(selectformcategory)) {
                setisLoading(true);
                dispatch(RequestsActions.LoadGetInmateDetailsPDRequest({ inmateId, requestFormTypeId })).then(x => {
                    setisLoading(false)
                });
            }
            setiscreate(true);
        }
        else {
            setErrorMessage({ StateNameID: currentLang?.ValidationSchema?.Please_Select_Category })
        }
    }
    // Handle page change
    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    useEffect(() => {
        if (selectformcategory && !isShowinboxlist) {
            handleRequestFormType(selectformcategory);
        }
        else if (isShowinboxlist) {
            handleMessageFromInbox();
        }
    }, [currentPage])

    // Handle rows per page change
    const handleonChangeRowsPerPage = (rowsPerPage) => {
        setrowPerPage(rowsPerPage);
    }

    const renderPaginatedTable = (data) => {
        return (
            (isShowGrid && !isShowinboxlist || isShowinboxlist) && (
                data?.length > 0 ? (
                    <Table
                        columns={columns}
                        data={data}
                        pagination={true}
                        handleONCLick={handleONCLick}
                        onChangeRowsPerPage={handleonChangeRowsPerPage}
                        onChangePage={handlePageChange}
                        totalRowCount={data[0]?.TotalRequestCount}
                        currentPage={currentPage}
                        paginationPerPage={rowPerPage}
                        paginationServer={true}
                    />
                ) : (
                    <span className="col-no-data">{currentLang?.No_Data_Found}</span>
                )
            )
        );
    };
    return (
        <>
            {isLoading && <Loader />}
            <div className="dashboard-container">
                <div className="dashboard-content">
                    <div className="d-flex justify-content-between align-items-center mb-1 pt-1">
                        <div className="align-self-start">
                            <div className="icon-container">
                                {/* {!isShowinboxlist ? <i className="fa fa-question icon"></i> : <i className="fa fa-comments icon"></i>} */}
                                <h3 className="find-inmate-head">{isShowinboxlist ? currentLang?.Requests?.Admin_Msg : currentLang?.Requests?.Requests}</h3>
                            </div>
                        </div>
                        <div className="">
                            {isshowFeedbackbtn &&
                                <Button
                                    variant="success"
                                    className="me-2"
                                    label={currentLang?.Buttons?.FeedBack_From_Staff}
                                    type="button"
                                    status="success"
                                    disabled={false}
                                    onClick={() => { setisshowNotice(true) }}
                                />
                            }
                            {(isShowinboxlist || isEdit || iscreate) ? (
                                <Button
                                    className='btn-danger'
                                    label={currentLang?.Buttons?.Back}
                                    type="button"
                                    status="back"
                                    onClick={handleBack}
                                />
                            ) :
                                (
                                    <Button
                                        variant="success"
                                        className="btn btn-danger me-2"
                                        label={currentLang?.Buttons?.Message_From_Inbox}
                                        type="button"
                                        status="success"
                                        disabled={false}
                                        unreadCount={LoadInmateMGUserRequestUnReadCountResponse?.length != 0 ? LoadInmateMGUserRequestUnReadCountResponse : 0}
                                        onClick={() => { setisShowinboxlist(true); setcurrentPage(1); setrowPerPage(10); handleMessageFromInbox() }}
                                    />
                                )}

                        </div>
                    </div>
                    <div className="divider mb-3"></div>

                    <div className={!isPdfdata ? "form-card" : 'card-default'}>
                        {isPdfdata ?
                            <> {formVisibility.divVisitorInfo && <VisitorInformation handleBack={handleBack} isEdit={isEdit} selectformcategory={selectformcategory} selectrowItem={selectrowItem} />}
                                {formVisibility.divRequest && <RequestRemedyForm handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divApplicationForm && <ApplicationForm setisshowNotice={setisshowNotice} isshowNotice={isshowNotice} setisshowFeedbackbtn={setisshowFeedbackbtn} selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divPDSRequestForm && <PublicDefenderServiceForm setisshowNotice={setisshowNotice} isshowNotice={isshowNotice} setisshowFeedbackbtn={setisshowFeedbackbtn} selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divForumRequestInfo && <RequestFormInfo setisEdit={setisEdit} isPdfdata={isPdfdata} setisPdfdata={setisPdfdata} isShowinboxlist={isShowinboxlist} selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divlegalResearch && <LegalResearchRequest selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                            </> : <ScrollContainer>
                                {/* Form Visibility Logic */}
                                {formVisibility.divVisitorInfo && <VisitorInformation handleBack={handleBack} isEdit={isEdit} selectformcategory={selectformcategory} selectrowItem={selectrowItem} />}
                                {formVisibility.divRequest && <RequestRemedyForm handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divApplicationForm && <ApplicationForm setisshowNotice={setisshowNotice} isshowNotice={isshowNotice} setisshowFeedbackbtn={setisshowFeedbackbtn} selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divPDSRequestForm && <PublicDefenderServiceForm setisshowNotice={setisshowNotice} isshowNotice={isshowNotice} setisshowFeedbackbtn={setisshowFeedbackbtn} selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divForumRequestInfo && <RequestFormInfo setisEdit={setisEdit} isPdfdata={isPdfdata} setisPdfdata={setisPdfdata} isShowinboxlist={isShowinboxlist} selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}
                                {formVisibility.divlegalResearch && <LegalResearchRequest selectformcategory={selectformcategory} handleBack={handleBack} isEdit={isEdit} selectrowItem={selectrowItem} />}

                                {(!iscreate && !isEdit) && (
                                    <>
                                        {!isShowinboxlist && (
                                            <div className="form-container">
                                                <SelectInput
                                                    options={InmateRequestFormPermissionDetails}
                                                    label={currentLang?.Requests?.Form_Category}
                                                    name="StateNameID"
                                                    className="mb-2 gap-2"
                                                    id="State"
                                                    width={100}
                                                    labelKey="label"
                                                    valueKey="value"
                                                    value={selectformcategory}
                                                    isClearable={false}
                                                    required
                                                    errorMessage={errorMessage}
                                                    placeholder={currentLang?.placeholder?.Select}
                                                    handleChange={e => { setcurrentPage(1); setrowPerPage(10); handleRequestFormType(e?.value); setErrorMessage({}) }}
                                                />
                                                <div className="button-group mb-3 mt-3">
                                                    <Button label={currentLang?.Buttons?.Create} className="btn btn-danger" status="success" type="submit" onClick={handlecreatefunction} />
                                                    <Button label={currentLang?.Buttons?.Reset} className="btn btn-warning" type="button" onClick={() => { setselectformcategory(''); setErrorMessage({}); setisShowGrid(false) }} />
                                                </div>
                                            </div>
                                        )}
                                        {renderPaginatedTable(
                                            isShowinboxlist ? InmateMGUserRequestFormSearchDetails : InmateRequestFormSearchDetails
                                        )}
                                    </>
                                )}
                            </ScrollContainer>}
                    </div>
                </div>

                {showPopup && (
                    <CustomModal
                        color={'#c8605e'}
                        content={modalContent}
                        onOkClick={() => { setShowPopup(false) }}
                    />
                )}
            </div>
        </>
    );
};

export default memo(Requests);
